import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
var baseUri = "WebApi.asmx/api/topicCommentService";
const store = {};
const mutations = {
    GET_TOPIC_COMMENT_LIST(state, posts) {
        state.topicCommentList = posts.commentList;
        state.allowAdd = posts.allowAdd;
        state.allowRead = posts.allowRead;
    },
    ADD_TOPIC_COMMENT(state, posts) {
        state.topicCommentList = posts.commentList;
    },
};
const state = {
    topicCommentList: [],
    allowAdd: false,
    allowRead: false
};
const getters = {};
const actions = {
    getTopciCommentList({ commit }, { topicId, args }) { 
        var formData = new FormData();
        formData.append("topicId", topicId);
        formData.append("args", args);
        axios
            .post(baseUri + '/GetList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_TOPIC_COMMENT_LIST', res.data);
                }
                else { 
                    alert(res.data.Error);
                }
            });
    },
    addComment({ commit }, { topicId, args, comment }) {
        window.LoadPanel.Show();
        var formData = new FormData();
        formData.append("topicId", topicId);
        formData.append("comment", comment);
        formData.append("args", args);
        axios
            .post(baseUri + '/AddComment', formData)
            .then(res => {
                window.LoadPanel.Hide();
                if (res.data.success == true) {
                    commit('ADD_TOPIC_COMMENT', res.data);
                }
                else {
                    window.LoadPanel.Hide();
                    alert(res.data.error);
                }
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}